import React, { FC, MouseEvent } from 'react'
import { BoxProps } from '@chakra-ui/core'
import { DetailRow } from '../DetailRow'
import { Counter } from '../Counter'

export interface Props extends BoxProps {
  title: string
  subTitle?: string
  addAction: (event: MouseEvent<HTMLButtonElement>) => void
  minusAction: (event: MouseEvent<HTMLButtonElement>) => void
  value: number
}

export const DetailRowWithCounter: FC<Props> = ({ title, subTitle, addAction, minusAction, value, ...props }) => {
  return (
    <DetailRow title={title} subTitle={subTitle} {...props} paddingLeft="6" paddingRight="0">
      <Counter
        hideMinus={true}
        noBorder={true}
        addAction={addAction}
        minusAction={minusAction}
        value={value}
        name={title}
      />
    </DetailRow>
  )
}
